<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="96px">
            <el-form-item label="关键词" prop="mchorderno">
                <el-input v-model="queryParams.mchorderno" placeholder="请输入关键词" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>

            <el-form-item label="系统名称" prop="mchid">
                <el-input v-model="queryParams.mchid" placeholder="请输入系统名称" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="系统类型" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择系统类型" clearable size="small">
                    <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel"
                        :value="dict.dictValue" />
                </el-select>
            </el-form-item>
            <el-form-item label="设备类型" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择设备类型" clearable size="small">
                    <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel"
                        :value="dict.dictValue" />
                </el-select>
            </el-form-item>

            <el-form-item label="联系人" prop="amount">
                <el-input v-model="queryParams.amount" placeholder="请输入联系人" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="对接状态" prop="amount">
                <el-input v-model="queryParams.amount" placeholder="请输入对接状态" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="工作状态" prop="amount">
                <el-input v-model="queryParams.amount" placeholder="请输入工作状态" clearable size="small"
                    @keyup.enter.native="handleQuery" />
            </el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
                    @click="handleUpdate">修改</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
                    @click="handleDelete">删除</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport"
                    v-hasPermi="['pay:payOrder:export']">导出</el-button>
            </el-col> 
        </el-row> -->

        <el-table v-loading="loading" :data="payOrderList" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55" align="center" /> -->
            <el-table-column label="系统名称" align="center" prop="payorderid" width="260" />
            <el-table-column label="系统类型" align="center" prop="mchName" />
            <el-table-column label="设备类型" align="center" prop="mchorderno" width="150" />
            <el-table-column label="联系人" align="center" prop="channelid" />
            <el-table-column label="联系电话" align="center" prop="amount" />
            <el-table-column label="完成时间" align="center" prop="currency" />
            <el-table-column label="对接状态" align="center" prop="status" />
            <el-table-column label="工作状态" align="center" prop="clientip" />
            <el-table-column label="备注" align="center" prop="subject" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" icon="el-icon-edit"
                        @click="handleUpdate(scope.row)">查看</el-button>
                    <el-button size="mini" type="text" icon="el-icon-edit"
                        @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button size="mini" type="text" icon="el-icon-delete"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination v-show="total > 0" :current-page.sync="queryParams.pageNum" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 50]" :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>





        <!-- 添加或修改支付订单对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="商户ID" prop="mchid">
                    <el-input v-model="form.mchid" placeholder="请输入商户ID" />
                </el-form-item>
                <el-form-item label="商户订单号" prop="mchorderno">
                    <el-input v-model="form.mchorderno" placeholder="请输入商户订单号" />
                </el-form-item>
                <el-form-item label="渠道ID" prop="channelid">
                    <el-input v-model="form.channelid" placeholder="请输入渠道ID" />
                </el-form-item>
                <el-form-item label="支付金额" prop="amount">
                    <el-input v-model="form.amount" placeholder="请输入支付金额,单位分" />
                </el-form-item>
                <el-form-item label="三位货币代码" prop="currency">
                    <el-input v-model="form.currency" placeholder="请输入三位货币代码,人民币:cny" />
                </el-form-item>
                <el-form-item label="支付状态">
                    <el-radio-group v-model="form.status">
                        <el-radio v-for="dict in statusOptions" :key="dict.dictValue"
                            :label="parseInt(dict.dictValue)">{{ dict.dictLabel }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="客户端IP" prop="clientip">
                    <el-input v-model="form.clientip" placeholder="请输入客户端IP" />
                </el-form-item>
                <el-form-item label="设备" prop="device">
                    <el-input v-model="form.device" placeholder="请输入设备" />
                </el-form-item>
                <el-form-item label="商品标题" prop="subject">
                    <el-input v-model="form.subject" placeholder="请输入商品标题" />
                </el-form-item>
                <el-form-item label="商品描述信息" prop="body">
                    <el-input v-model="form.body" placeholder="请输入商品描述信息" />
                </el-form-item>
                <el-form-item label="特定渠道发起时额外参数" prop="extra">
                    <el-input v-model="form.extra" type="textarea" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item label="渠道商户ID" prop="channelmchid">
                    <el-input v-model="form.channelmchid" placeholder="请输入渠道商户ID" />
                </el-form-item>
                <el-form-item label="渠道订单号" prop="channelorderno">
                    <el-input v-model="form.channelorderno" placeholder="请输入渠道订单号" />
                </el-form-item>
                <el-form-item label="渠道支付错误码" prop="errcode">
                    <el-input v-model="form.errcode" placeholder="请输入渠道支付错误码" />
                </el-form-item>
                <el-form-item label="渠道支付错误描述" prop="errmsg">
                    <el-input v-model="form.errmsg" placeholder="请输入渠道支付错误描述" />
                </el-form-item>
                <el-form-item label="扩展参数1" prop="param1">
                    <el-input v-model="form.param1" placeholder="请输入扩展参数1" />
                </el-form-item>
                <el-form-item label="扩展参数2" prop="param2">
                    <el-input v-model="form.param2" placeholder="请输入扩展参数2" />
                </el-form-item>
                <el-form-item label="通知地址" prop="notifyurl">
                    <el-input v-model="form.notifyurl" placeholder="请输入通知地址" />
                </el-form-item>
                <el-form-item label="通知次数" prop="notifycount">
                    <el-input v-model="form.notifycount" placeholder="请输入通知次数" />
                </el-form-item>
                <el-form-item label="最后一次通知时间" prop="lastnotifytime">
                    <el-input v-model="form.lastnotifytime" placeholder="请输入最后一次通知时间" />
                </el-form-item>
                <el-form-item label="订单失效时间" prop="expiretime">
                    <el-input v-model="form.expiretime" placeholder="请输入订单失效时间" />
                </el-form-item>
                <el-form-item label="订单支付成功时间" prop="paysucctime">
                    <el-input v-model="form.paysucctime" placeholder="请输入订单支付成功时间" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "equipmentManage",
    components: {
    },
    data() {
        return {
            // 遮罩层
            loading: false,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 支付订单表格数据
            payOrderList: [],
            // 支付渠道列表
            channelList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 支付状态,0-订单生成,1-支付中(目前未使用),2-支付成功,3-业务处理完成字典
            statusOptions: [
                {
                    dictLabel: "订单生成",
                    dictValue: "0",
                },
                {
                    dictLabel: "支付中(目前未使用)",
                    dictValue: "1",
                },
                {
                    dictLabel: "支付成功",
                    dictValue: "2",
                },
                {
                    dictLabel: "业务处理完成",
                    dictValue: "3",
                },
            ],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                mchid: null,
                mchorderno: null,
                channelid: null,
                amount: null,
                status: null,
                clientip: null,
                device: null,
                subject: null,
                channelmchid: null,
                channelorderno: null,
                errcode: null,
                lastnotifytime: null,
                expiretime: null,
                paysucctime: null,
            },
            // 表单参数
            form: {},
            //列表动态隐藏
            colData: [
                { title: "支付订单号", istrue: true },
                { title: "商户", istrue: true },
                { title: "商户订单号", istrue: true },
                { title: "渠道ID", istrue: true },
                { title: "支付金额", istrue: true },
                { title: "三位货币代码,人民币:cny", istrue: false },
                { title: "支付状态", istrue: true },
                { title: "客户端IP", istrue: false },
                { title: "设备", istrue: false },
                { title: "商品标题", istrue: true },
                { title: "商品描述信息", istrue: false },
                { title: "特定渠道发起时额外参数", istrue: false },
                { title: "渠道商户ID", istrue: false },
                { title: "渠道订单号", istrue: false },
                { title: "渠道支付错误码", istrue: false },
                { title: "渠道支付错误描述", istrue: false },
                { title: "扩展参数1", istrue: false },
                { title: "扩展参数2", istrue: false },
                { title: "通知地址", istrue: false },
                { title: "通知次数", istrue: false },
                { title: "最后一次通知时间", istrue: false },
                { title: "订单失效时间", istrue: false },
                { title: "订单支付成功时间", istrue: false }
            ],
            checkBoxGroup: [],
            checkedColumns: [],


            // 表单校验
            rules: {
                mchid: [
                    { required: true, message: "商户ID不能为空", trigger: "blur" }
                ],
                mchorderno: [
                    { required: true, message: "商户订单号不能为空", trigger: "blur" }
                ],
                channelid: [
                    { required: true, message: "渠道ID不能为空", trigger: "blur" }
                ],
                amount: [
                    { required: true, message: "支付金额,单位分不能为空", trigger: "blur" }
                ],
                currency: [
                    { required: true, message: "三位货币代码,人民币:cny不能为空", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "支付状态,0-订单生成,1-支付中(目前未使用),2-支付成功,3-业务处理完成不能为空", trigger: "blur" }
                ],
                subject: [
                    { required: true, message: "商品标题不能为空", trigger: "blur" }
                ],
                body: [
                    { required: true, message: "商品描述信息不能为空", trigger: "blur" }
                ],
                channelmchid: [
                    { required: true, message: "渠道商户ID不能为空", trigger: "blur" }
                ],
                notifyurl: [
                    { required: true, message: "通知地址不能为空", trigger: "blur" }
                ],
                notifycount: [
                    { required: true, message: "通知次数不能为空", trigger: "blur" }
                ],
            }
        };
    },
    created() {
        this.getList();


    },
    // 监控列隐藏
    watch: {

    },
    methods: {
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        /** 查询支付订单列表 */
        getList() {
            // this.loading = true;
            // this.$http.get("/api/payOrder/list2", {
            //     params: {
            //         ...this.queryParams
            //     }
            // }).then(res => {
            //     if (res.data.code == 0) {
            //         this.payOrderList = response.rows;
            //         this.total = response.total;
            //     }
            //     this.loading = false;
            // })

        },
        // 支付状态,0-订单生成,1-支付中(目前未使用),2-支付成功,3-业务处理完成字典翻译
        statusFormat(row, column) {
            return this.selectDictLabel(this.statusOptions, row.status);
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                payorderid: null,
                mchid: null,
                mchorderno: null,
                channelid: null,
                amount: null,
                currency: null,
                status: 0,
                clientip: null,
                device: null,
                subject: null,
                body: null,
                extra: null,
                channelmchid: null,
                channelorderno: null,
                errcode: null,
                errmsg: null,
                param1: null,
                param2: null,
                notifyurl: null,
                notifycount: null,
                lastnotifytime: null,
                expiretime: null,
                paysucctime: null,
                createBy: null,
                createTime: null,
                updateBy: null,
                updateTime: null
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.payorderid)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加支付订单";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const payorderid = row.payorderid || this.ids
            getPayOrder(payorderid).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改支付订单";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.payorderid != null) {
                        updatePayOrder(this.form).then(response => {
                            this.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addPayOrder(this.form).then(response => {
                            this.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const payorderids = row.payorderid || this.ids;
            this.$confirm('是否确认删除支付订单编号为"' + payorderids + '"的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function () {
                return delPayOrder(payorderids);
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            })
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('pay/payOrder/export', {
                ...this.queryParams
            }, `pay_payOrder.xlsx`)
        },

    }
};
</script>
<style scoped="scoped">
.app-container {
    padding-top: 10px;
}
</style>
